export default __webpack_public_path__ + "static/media/img-guide-01@3x.590b6684.png";